export const kcbobcatPrompts = [
  {
    text: `I'm Searching for Equipment`,
    children: [
      {
        text: `Searching for New Equipment`,
        parentText: "I'm Searching for Equipment",
        children: [
          {
            text: 'View New Loaders',
            parentText: 'Searching for New Equipment',
            url: 'https://kcbobcat.com/new-bobcat-loaders/'
          },
          {
            text: 'View New Excavators',
            parentText: 'Searching for New Equipment',
            url: 'https://kcbobcat.com/new-bobcat-excavators/'
          },
          {
            text: 'View New Tractors',
            parentText: 'Searching for New Equipment',
            url: 'https://kcbobcat.com/new-bobcat-tractors/'
          },
          {
            text: 'View New Work Machines',
            parentText: 'Searching for New Equipment',
            url: 'https://kcbobcat.com/new-bobcat-toolcat-utility-work-machines/'
          },
          {
            text: 'View New Utility Vehicles',
            parentText: 'Searching for New Equipment',
            url: 'https://kcbobcat.com/new-bobcat-utility-vehicles/'
          },
          {
            text: 'View New Telehandlers',
            parentText: 'Searching for New Equipment',
            url: 'https://kcbobcat.com/new-bobcat-telehandlers/'
          },
          {
            text: 'View New Mowers',
            parentText: 'Searching for New Equipment',
            url: 'https://kcbobcat.com/new-bobcat-mowers/'
          }
        ]
      },
      {
        text: `Looking for Used Equipment`,
        parentText: "I'm Searching for Equipment"
      },
      {
        text: `Current Deals & Offers`,
        parentText: "I'm Searching for Equipment"
      },
      {
        text: `Searching for Financing Info`,
        parentText: "I'm Searching for Equipment"
      },
      {
        text: `I Have a General Question `,
        parentText: "I'm Searching for Equipment"
      }
    ]
  },
  {
    text: `I'm Searching for Parts`,
    children: [
      {
        text: 'Shop KC Bobcat Parts',
        parentText: "I'm Searching for Parts"
      },
      {
        text: 'Help Ordering Parts',
        parentText: "I'm Searching for Parts"
      }
    ]
  },
  {
    text: `My Machine Needs Service`,
    children: [
      {
        text: 'Schedule Equipment Service',
        parentText: 'My Machine Needs Service'
      },
      {
        text: 'Schedule Field Service',
        parentText: 'My Machine Needs Service'
      },
      {
        text: 'I Have General Service Questions ',
        parentText: 'My Machine Needs Service'
      }
    ]
  },
  {
    text: `Trade In`,
    children: [
      {
        text: `Get a Trade In Quote`,
        parentText: 'Trade In'
      },
      {
        text: `General Questions`,
        parentText: 'Trade In'
      }
    ]
  },
  {
    text: `Looking for a Rental`,
    children: [
      {
        text: 'Search Equipment Rentals ',
        parentText: 'Looking for a Rental'
      },
      {
        text: 'Attachments For Rent',
        parentText: 'Looking for a Rental'
      },
      {
        text: 'Request Rental Quote',
        parentText: 'Looking for a Rental'
      }
    ]
  },

  {
    text: `Quick Question`,
    children: [
      {
        text: 'Interested In Job Openings',
        parentText: 'Quick Question'
      },
      {
        text: 'Search Locations & Contact Info',
        parentText: 'Quick Question'
      },
      {
        text: 'Search KCB Knowledge Base',
        parentText: 'Quick Question'
      },
      {
        text: 'Something Else',
        parentText: 'Quick Question'
      }
    ]
  }
]
